import React from 'react';
import {Link} from 'gatsby';

const links = [
    {name: 'about', href:'/about'}, 
    {name: 'contact', href: '/contact'}
];

const getLinks = (active) => {
    return (
        <ul>
            {
                links.map(link => {
                    return (
                        <li key={link.name} className={`main-menu-link ${link.name === active ? 'active' : ''}`}>
                            <Link to={link.href}>{link.name}</Link>
                        </li>
                    );
                })
            }
        </ul>
    )
}

export default (props) => {
    return (
        <header>
            <div className="header-container">
                <span className="logo">5 Lambdas</span>
                {
                    //TODO make a better mobile menu
                    //props.desktop ? (<ul>{getLinks(props.active)}</ul>) : "mobile"
                    (<ul>{getLinks(props.active)}</ul>)
                }
            </div>
        </header>
    )
};